export const IT3_LANGUAGE_TO_IT4 = new Map([
  ['English', 'en'],
  ['English_UK', 'en-GB'],
  ['Arabic', 'ar'],
  ['Bulgarian', 'bg'],
  ['Chinese_Simplified', 'zh-hans'],
  ['Chinese_Traditional', 'zh-hant'],
  ['Croatian', 'hr'],
  ['Czech', 'cs'],
  ['Danish', 'da'],
  ['Dutch', 'nl'],
  ['Estonian', 'et'],
  ['Finnish', 'fi'],
  ['French', 'fr'],
  ['German', 'de'],
  ['Greek', 'el'],
  ['Hebrew', 'he'],
  ['Hindi', 'hi'],
  ['Hungarian', 'hu'],
  ['Icelandic', 'is'],
  ['Indonesian', 'id'],
  ['Italian', 'it'],
  ['Japanese', 'ja'],
  ['Korean', 'ko'],
  ['Latvian', 'lv'],
  ['Lithuanian', 'lt'],
  ['Norwegian', 'no'],
  ['Polish', 'pl'],
  ['Portuguese', 'pt'],
  ['Romanian', 'ro'],
  ['Russian', 'ru'],
  ['Serbian', 'sr'],
  ['Slovak', 'sk'],
  ['Spanish', 'es'],
  ['Swedish', 'sv'],
  ['Thai', 'th'],
  ['Turkish', 'tr'],
  ['Vietnamese', 'vi'],
]);

export const IT4_LANGUAGE_TO_IT3 = new Map([
  ['en', 'English'],
  ['en-GB', 'English_UK'],
  ['ar', 'Arabic'],
  ['bg', 'Bulgarian'],
  ['zh-hans', 'Chinese_Simplified'],
  ['zh-hant', 'Chinese_Traditional'],
  ['hr', 'Croatian'],
  ['cs', 'Czech'],
  ['da', 'Danish'],
  ['nl', 'Dutch'],
  ['et', 'Estonian'],
  ['fi', 'Finnish'],
  ['fr', 'French'],
  ['de', 'German'],
  ['el', 'Greek'],
  ['he', 'Hebrew'],
  ['hi', 'Hindi'],
  ['hu', 'Hungarian'],
  ['is', 'Icelandic'],
  ['id', 'Indonesian'],
  ['it', 'Italian'],
  ['ja', 'Japanese'],
  ['ko', 'Korean'],
  ['lv', 'Latvian'],
  ['lt', 'Lithuanian'],
  ['no', 'Norwegian'],
  ['pl', 'Polish'],
  ['pt', 'Portuguese'],
  ['ro', 'Romanian'],
  ['ru', 'Russian'],
  ['sr', 'Serbian'],
  ['sk', 'Slovak'],
  ['es', 'Spanish'],
  ['sv', 'Swedish'],
  ['th', 'Thai'],
  ['tr', 'Turkish'],
  ['vi', 'Vietnamese'],
]);
